import { COLOR } from 'vars/index'

export const Background = {
  SURFACE_DARK_6: COLOR.SURFACE_DARK_6,
  OPACITY_PRESSED: COLOR.ADDITIONAL_BLUE,
  TEXT_IN_BUTTONS_PRIMARY: COLOR.ADDITIONAL_ORANGE,
  ACCENT_PRIMARY_GRADIENT: COLOR.ACCENT_PRIMARY_GRADIENT,
  TEXT_DISABLED: COLOR.DISABLED,
  DISABLED: COLOR.DISABLED,
} as const
export type Background = (typeof Background)[keyof typeof Background]

export const Color = {
  SURFACE_OPACITY_LIGHT_20: COLOR.SURFACE_OPACITY_LIGHT_20,
  TEXT_ICON_PRIMARY: COLOR.TEXT_ICON_PRIMARY,
} as const
export type Color = (typeof Color)[keyof typeof Color]
